import consola from 'consola'
import validate from 'validate.js'
import '../typedefs'

const logger = consola.withScope('phaneroo').withTag('validator')

/**
 * All prayer requests services validators go here:
 */

/**
 * Validates createPrayerRequest payload
 * @param {{ title: String, content: String, category_id: String }} payload category payload
 */
export function validateCreatePrayerRequest (payload) {
  if (!validate.isObject(payload)) {
    throw new TypeError(`Function "createPrayerRequest" expected paylaod of type "object", but got ${typeof payload}`)
  }

  const contraints = {
    title: {
      type: 'string'
    },
    content: {
      type: 'string',
      presence: true
    },
    category_id: {
      type: 'string',
      presence: true
    }
  }

  const invalid = validate(payload, contraints)

  if (invalid) {
    throw new Error(JSON.stringify(invalid))
  }

  return true
}

export function validateMarkAllPrayerRequestsAsRead (payload) {
  if (!validate.isArray(payload)) {
    throw new TypeError(`Function "markAllAsRead" expected payload of type "array", but got "${typeof payload}" instead.`)
  }

  payload.forEach(id => {
    if (typeof id !== 'string') {
      logger.warn(`Function "markAllAsRead" expected payload of type "array", but got "${typeof payload}" instead.`)
    }
  })
}
